<template>
  <div
    class="ws-state-select"
    :class="[
      { round: round },
      { active: menuActive },
      { 'is-error': errors && errors.length },
      { 'is-disabled': _disabled },
    ]"
    v-click-outside="$_onClickOutside"
  >
    <a
      href="#"
      ref="wsStateSelectButton"
      @click.prevent="$_onOpenClick()"
      class="ws-state-select__button"
    >
      <div v-if="value || value == 0" class="ws-state-select__button-text">{{ _valueText }}</div>
      <div v-else class="ws-state-select__placeholder">{{ _placeholder }}</div>
      <v-icon
        v-if="clearable && value && JSON.stringify !== '{}'"
        class="icon text-body-1"
        @click.stop.prevent="$_onClearClick()"
        >mdi-close-circle-outline</v-icon
      >
      <v-icon class="icon">mdi-menu-down</v-icon>
    </a>
    <div v-if="menuActive" class="ws-state-select__menu" :class="{ top: _menuOpenUpward }">
      <div class="ws-state-select__options">
        <a
          v-for="(item, itemIndex) in items"
          :key="itemIndex"
          href="#"
          @click.prevent="$_onOptionClick(item)"
          :class="{ active: $_activeCheck(item) }"
        >
          <div v-show="multiple" class="checkbox">
            <v-icon v-if="$_activeCheck(item)">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </div>
          <p>{{ item.text }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { shouldOpenDropdownUpward } from '@/helpers/dropdownViewportFlip';

export default {
  props: {
    errors: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'select',
    },
    value: {
      type: [Number, String, Array, RegExp, Boolean],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    requiredField: {
      default: null,
    },
    requiredFieldState: {
      default: null,
    },
    defaultValue: {
      type: [String, Number, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menuActive: false,
      menuAnchorBounds: { top: 0, bottom: 0 },
      window: { width: 0, height: 0 },
    };
  },
  computed: {
    _disabled() {
      return (
        !this.items ||
        this.items.length === 0 ||
        this.disabled ||
        (this.parent && !this.parentState) ||
        (this.requiredField && (!this.requiredFieldState || this.requiredFieldState.length === 0))
      );
    },
    _valueText() {
      if (this.value === undefined) return '';
      if (!this.multiple) {
        const tarItem = this.items.find((e) => e.value == this.value);
        return tarItem ? tarItem.text : '';
      }
      return this.value
        .map((valueItem) => {
          const tarItem = this.items.find((e) => e.value == valueItem);
          return tarItem ? tarItem.text : null;
        })
        .filter(Boolean)
        .join(', ');
    },
    _placeholder() {
      if (!this.items || this.items.length === 0) return '無選項';
      return this.placeholder;
    },
    _menuOpenUpward() {
      return shouldOpenDropdownUpward(this.menuAnchorBounds, {
        estimatedDropdownHeight: 360,
        viewportHeight: this.window.height,
      });
    },
  },
  mounted() {
    this.$_getDefaultValue();
  },
  methods: {
    $_onOpenClick() {
      if (this._disabled) return;
      this.$_getSelectButtonBounds();
      this.menuActive = !this.menuActive;
      if (this.menuActive) {
        this.$_syncWindowSize();
      }
    },
    $_syncWindowSize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_getSelectButtonBounds() {
      const el = this.$refs.wsStateSelectButton;
      if (!el) return;
      const r = el.getBoundingClientRect();
      this.menuAnchorBounds = { top: r.top, bottom: r.bottom };
    },
    $_activeCheck(item) {
      if (!this.value) return;
      return this.multiple ? this.value.includes(item.value) : this.value == item.value;
    },
    $_onOptionClick(item) {
      if (!this.multiple) {
        this.$emit('input', item.value);
        this.menuActive = false;
        return;
      }
      const value = this.value ? JSON.parse(JSON.stringify(this.value)) : [];
      const itemIndex = value.findIndex((e) => e == item.value);
      if (itemIndex >= 0) {
        value.splice(itemIndex, 1);
      } else {
        value.push(item.value);
      }
      this.$emit('input', value);
    },
    $_onClickOutside() {
      this.menuActive = false;
    },
    $_getDefaultValue() {
      if (!this.defaultValue || this.value) return;
      if (!this.multiple) {
        this.$emit('input', this.defaultValue);
        return;
      }
      if (typeof this.defaultValue === 'string') {
        this.$emit('input', [this.defaultValue]);
      } else {
        this.$emit('input', this.defaultValue);
      }
    },
    $_onClearClick() {
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-state-select.scss';
</style>
